import { render, staticRenderFns } from "./ContactIndex.vue?vue&type=template&id=36acad1e&"
import script from "./ContactIndex.vue?vue&type=script&lang=js&"
export * from "./ContactIndex.vue?vue&type=script&lang=js&"
import style0 from "./ContactIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports